import { useCasFilteredNavigation } from 'src/compass/site/routes';

export default function useCasNavigationMenuData() {
  const navData = useCasFilteredNavigation();

  const formattedNavData = navData.map((menu) => ({
    title: menu.menuTitle,
    path: menu.path,
    icon: menu.icon,
    children: menu.subMenus.map((subMenu) => ({
      title: subMenu.title,
      path: subMenu.path,
      hidden: subMenu.hidden,
    })),
  }));

  return [
    {
      subheader: 'Compass Portal',
      items: formattedNavData,
    },
  ];
}
